export const MODULE_NAME = 'views/cottage-contact'
export const COTTAGE_CONTACT_STORE_ID = `${MODULE_NAME}/store`

export const NUXT_PAGE_COTTAGE_CONTACT_NAME = 'cottage-contact-page'
